import React from 'react';
type LogoProps = {
  className?: string;
};
export function Logo({
  className = ''
}: LogoProps) {
  return <span className={`inline-flex items-center gap-[0.3em] font-display font-extrabold tracking-[-0.04em] ${className}`} data-id="element-380" data-mp="8u4t8qvvw1pz">
      <BlockMark className="h-[0.86em] w-auto" data-id="element-381" data-mp="3qb5x4sr70tmc" />
      WALZ
    </span>;
}

// Brutalist mark: a solid machined block — one chamfered corner and a through-bore.
export function BlockMark({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-382" data-mp="rrp8r7crdnxx">
      <path fillRule="evenodd" d="M0 0H16L24 8V24H0Z M12 7.5A4.5 4.5 0 1 0 12 16.5A4.5 4.5 0 1 0 12 7.5Z" data-id="element-383" data-mp="ds6bj9lhjx0e" />
    </svg>;
}